import { GlobalConfig } from "ngx-toastr/toastr/toastr-config";

export const TOAST_CONFIG: Partial<GlobalConfig> = {
  // timeOut: 100000000,
  // extendedTimeOut: 100000000,
  positionClass: "toast-bottom-center",
  preventDuplicates: true,
};
